import Format from '../utility/Format';
import LaneClosureRequest from './LaneClosureRequest';
import Organization from './Organization';
import Contravention from './Contravention';
// import {
// 	format
// } from 'core-js/fn/date';
export default class LcrChangeRequestList {

	static get getAuditTypeOptions() {
		return [
			{
				id: 1,
				name: 'New Lane Closure Request'
			},
			{
				id: 2,
				name: 'Updated Lane Closure Request'
			},
			{
				id: 3,
				name: 'Requested Changed'
			},
			{
				id: 4,
				name: 'New Message'
			},
			{
				id: 5,
				name: 'Approved Lane Closure Request'
			},
			{
				id: 6,
				name: 'Cancelled Lane Closure Request'
			},
			{
				id: 7,
				name: 'Denied Lane Closure Request'
			},
			{
				id: 8,
				name: 'Notification - Expired Request'
			},
			{
				id: 9,
				name: 'Notification - Updated Request'
			},
			{
				id: 10,
				name: 'Viewed Lane Closure Request'
			},
			{
				id: 11,
				name: 'Notification - New Request'
			},
			{
				id: 12,
				name: 'Reported Closure'
			},
			{
				id: 13,
				name: 'Reported Restrictions'
			},
			{
				id: 14,
				name: 'Reported Contravention'
			},
			{
				id: 15,
				name: 'Updated Contravention'
			},
			{
				id: 16,
				name: 'Duplicated Lane Closure Request'
			},
			{
				id: 17,
				name: 'Completed Lane Closure Request'
			},
			{
				id: 18,
				name: 'Attached File to Lane Closure Request'
			},
			{
				id: 19,
				name: 'New User'
			},
			{
				id: 20,
				name: 'Updated User'
			},
			{
				id: 21,
				name: 'New Organization'
			},
			{
				id: 22,
				name: 'Updated Organization'
			},
			{
				id: 23,
				name: 'New Organization Request'
			},
			{
				id: 24,
				name: 'Approved Organization Request'
			},
			{
				id: 25,
				name: 'Denied Organization Request'
			},
			{
				id: 26,
				name: 'Log In'
			},
			{
				id: 27,
				name: 'Log Out'
			},
			{
				id: 28,
				name: 'Lane Closure Request Status Changed'
			},
			{
				id: 29,
				name: 'Updated Attached File'
			},
		];
	}

	constructor(data, $t, vueObj) {
		data.forEach(item => {
			this.constructFields(item, $t, vueObj);
		});
	}

	constructFields(log, $t, vueObj) {
		if (log.dataModel == "LaneClosureRequest") {
			let changedFieldkey = null;
			let changedFieldValue = null;
			if (log.changes != null) {
				changedFieldkey = JSON.parse(log.changes)["Key"];
				changedFieldValue = JSON.parse(log.changes)["Value"];
			}
			let details = null;
			if (log.changesDetails) {
				details = JSON.parse(log.changesDetails);
			}
			if (details == null) {
				// return;
			}
			if (["ToDate", "FromDate"].includes(changedFieldkey)) {
				this[changedFieldkey] = new ChangeRequestLogField({
					label: changedFieldkey,
					value: Object.values(details)
				});
			} else if (["ToTime", "FromTime"].includes(changedFieldkey)) {
				this[changedFieldkey] = new ChangeRequestLogField({
					label: changedFieldkey,
					value: Object.values(details)
				});
			} else if (changedFieldkey == "NatureOfWorkId") {
				this[changedFieldkey] = new ChangeRequestLogField({
					label: changedFieldkey,
					value: changedFieldValue,
					formatter: value => {
						return Format.searchById(value, LaneClosureRequest.getNatureOfWorkOptions).name
					}
				});
			} else if (changedFieldkey == "RequesterProjectId") {
				this[changedFieldkey] = new ChangeRequestLogField({
					label: changedFieldkey,
					value: details["RequesterProject"]
				});
			} else if (["RequesterId", "ClosureReporterId", "RestrictionReporterId", "OwnerId"].includes(changedFieldkey)) {
				var detailField = details[changedFieldkey.replace("Id", "")];
				let oldName = "None",
					newName = "None";
				if (detailField[0]) oldName = `${detailField[0].FirstName} ${detailField[0].LastName}, ${this.getOrganizationTreeText(detailField[0])}`;
				if (detailField[1]) newName = `${detailField[1].FirstName} ${detailField[1].LastName}, ${this.getOrganizationTreeText(detailField[1])}`;
				this[changedFieldkey] = new ChangeRequestLogField({
					label: changedFieldkey,
					value: [oldName, newName]
				});
			} else if (changedFieldkey == "IsEmergency") {
				this[changedFieldkey] = new ChangeRequestLogField({
					label: changedFieldkey,
					value: changedFieldValue,
					formatter: value => value == 0 ? "Not Emergency" : "Emergency"
				});
			} else if (changedFieldkey == "IsUnderTwoHours") {
				this[changedFieldkey] = new ChangeRequestLogField({
					label: changedFieldkey,
					value: changedFieldValue,
					formatter: value => value == 0 ? "More than Two Hours" : "Less than Two Hours"
				});
			} else if (changedFieldkey == "WorkDoneForId") {
				this[changedFieldkey] = new ChangeRequestLogField({
					label: changedFieldkey,
					value: details["WorkDoneForName"]
				});
			} else if (["RecordStatusId", "ApprovalStatusId", "CompleteTypeId"].includes(changedFieldkey)) {
				this[changedFieldkey] = new ChangeRequestLogField({
					label: changedFieldkey,
					value: changedFieldValue,
					formatter: value => {
						if (value == null) return "None";

						switch (changedFieldkey) {
							case "RecordStatusId":
								return Format.searchById(value, LaneClosureRequest.getLaneClosureRequestRecordStatusIdOptions).name;
							case "ApprovalStatusId":
								return Format.searchById(value, LaneClosureRequest.getApprovalStatusIdOptions).name;
							case "CompleteTypeId":
								return Format.searchById(value, LaneClosureRequest.getCompleteTypeIdOptions).name;
						}
					}
				});
			} else if (changedFieldkey == "DirectionId") {
				this[changedFieldkey] = new ChangeRequestLogField({
					label: changedFieldkey,
					value: changedFieldValue,
					formatter: value => Format.searchById(value, LaneClosureRequest.getDirectionIdOptions).name
				});
			} else if (changedFieldkey == "Attachment") {
				let lines = details["Attachments"].map(x => new ChangeRequestLogLine(`Attached <b>${x.Filename} (${x.Description})</b>`));
				this[changedFieldkey] = new ChangeRequestLogField({
					label: changedFieldkey,
					logItems: lines
				});
			} else if (changedFieldkey == "TempTrafficControl") {
				this[changedFieldkey] = new ChangeRequestLogField({
					label: changedFieldkey,
					value: changedFieldValue,
					formatter: value => value == 0 ? "No" : "Yes"
				});
			} else {
				console.log(changedFieldkey, changedFieldValue);
				this[changedFieldkey] = new ChangeRequestLogField({
					label: changedFieldkey,
					value: changedFieldValue
				});
			}
		}

		// Alt requesters / reporters


		else if (["lcrAltRequester", "lcrAltClosureReporter", "lcrAltRestrictionReporter", "lcrRequester", "lcrClosureReporter", "lcrRestrictionReporter"].includes(log.dataModel)) {
			let label = log.dataModel;
			let details = JSON.parse(log.changesDetails)
			let deleted = [],
				added = [];

			if (details != null) {

				if (details["Deleted"]) {
					deleted = details["Deleted"].map(requester => `Removed <b>${requester.FirstName} ${requester.LastName}, ${this.getOrganizationTreeText(requester)}</b>.`).map(line => new ChangeRequestLogLine({
						faType: 'minus-circle',
						text: line
					}));
				}
				if (details["Added"]) {
					added = details["Added"].map(requester => `Assigned <b>${requester.FirstName} ${requester.LastName}, ${this.getOrganizationTreeText(requester)}</b>.`).map(line => new ChangeRequestLogLine({
						faType: 'plus-circle',
						text: line
					}));
				}

				if (deleted.length > 0 || added.length > 0) {
					this[label] = new ChangeRequestLogField({
						label: label,
						logItems: deleted.concat(added)
					});
				}
			}
		}

		// Lanes Bicycles Sidewalk Signals Restrictions
		else if (["lcrLane", "lcrBicycle", "lcrSidewalk", "lcrTrafficSignal", "lcrRestriction", "lcrParkingRemoval"].includes(log.dataModel)) {
			let label = log.dataModel;
			let details = JSON.parse(log.changesDetails)
			let deleted = [],
				added = [],
				changed = [],
				updated = []

			let getlaneOptionIdName = (lane) => {
				let result = "";
				switch (label) {
					case "lcrLane":
						result = Format.searchByGroupedId(lane.LaneId, LaneClosureRequest.getLaneAffectedOptions);
						result = `<img src="${result.img}" width="25" height="25" /> ${result.name} on ${lane.StreetName} between <b>${lane.FromStreet}</b> and <b>${lane.ToStreet}</b>`;
						break;
					case "lcrBicycle":
						result = Format.searchById(lane.BicycleLaneId, LaneClosureRequest.getBicycleLaneOptions);
						result = `<img src="${result.img}" width="20" height="20" /> ${result.name} on ${lane.StreetName} between <b>${lane.FromStreet}</b> and <b>${lane.ToStreet}</b>`;
						break;
					case "lcrParkingRemoval":
						if (lane.From && lane.To) {
							result = "changed details of one.";
							var fromResult = Format.searchById(lane.From.ParkingLaneId, LaneClosureRequest.getParkingLaneOptions);
							var toResult = Format.searchById(lane.To.ParkingLaneId, LaneClosureRequest.getParkingLaneOptions);
							// var changedLane = false;
							// var changedStartAddress = false;
							// var changedEndAddress = false;
							// var changedParkingRemovalMetres = false;
							// if (fromResult != toResult) {
							// 	changedLane = true;
							// }
							// if (lane.From.ParkingStartAddress != lane.To.ParkingStartAddress) {
							// 	changedStartAddress = true;
							// }
							// if (lane.From.ParkingEndAddress != lane.To.ParkingEndAddress) {
							// 	changedEndAddress = true;
							// }
							// if (lane.From.ParkingRemovalMetres != lane.To.ParkingRemovalMetres) {
							// 	changedParkingRemovalMetres = true;
							// }
							result = `<br/><em>BEFORE:</em> <img src="${fromResult.img}" width="20" height="20" /> ${fromResult.name}<br/><b>${lane.From.ParkingStartAddress}</b> to <b>${lane.From.ParkingEndAddress}</b> (${lane.From.ParkingRemovalMetres} metres)</b>`;

							result += `<br/><em>AFTER:</em> <img src="${toResult.img}" width="20" height="20" /> ${toResult.name} from <b>${lane.To.ParkingStartAddress}</b> to <b>${lane.To.ParkingEndAddress}</b> (${lane.To.ParkingRemovalMetres} metres)`;

						} else {
							result = Format.searchById(lane.ParkingLaneId, LaneClosureRequest.getParkingLaneOptions);
							result = `<img src="${result.img}" width="20" height="20" /> ${result.name}, <b>${lane.ParkingStartAddress}</b> to <b>${lane.ParkingEndAddress}</b>  (${lane.ParkingRemovalMetres} metres)`;
						}
						break;
					case "lcrSidewalk":
						result = Format.searchById(lane.SidewalkId, LaneClosureRequest.getSidewalkOptions);
						result = `<img src="${result.img}" width="20" height="20" /> ${result.name} on ${lane.StreetName} between <b>${lane.FromStreet}</b> and <b>${lane.ToStreet}</b>`;
						break;
					case "lcrRestriction":
						result = Format.searchById(lane.RestrictionTypeId, LaneClosureRequest.getTurningRestrictionTypeOptions);
						if (typeof result == "undefined") {
							result = null;
						} else {
							let direction = Format.searchById(lane.DirectionId, LaneClosureRequest.getDirectionIdOptions).name;
							result = `${lane.AffectedStreet} between <b>${lane.FromStreet}</b> and <b>${lane.ToStreet}</b> <img src="${result.img}" width="20" height="20" /> ${direction} ${result.name} onto <b>${lane.CrossStreet}</b>`;
						}
						break;
					case "lcrTrafficSignal":
						result = `<img src="/img/lcr/traffic-light.png" width="20" height="20" /> ${lane.StreetName} between <b>${lane.FromStreet}</b> and <b>${lane.ToStreet}</b>`;
						break;
				}

				return result;
			}
			if (details != null) {

				if (details["Deleted"]) {
					deleted = details["Deleted"].map(lane => `Removed ${getlaneOptionIdName(lane)}`).map(line => new ChangeRequestLogLine({
						faType: 'minus-circle',
						text: line
					}));
				}
				if (details["Added"]) {
					added = details["Added"].map(lane => `Added ${getlaneOptionIdName(lane)}`).map(line => new ChangeRequestLogLine({
						faType: 'plus-circle',
						text: line
					}));
				}
				if (details["Changed"]) {
					changed = details["Changed"].map(lane => `Changed ${getlaneOptionIdName(lane)}`).map(line => new ChangeRequestLogLine({
						faType: '',
						text: line
					}));
				}
				if (details["Updated"]) {
					updated = details["Updated"].map(lane => `Updated ${getlaneOptionIdName(lane)}`).map(line => new ChangeRequestLogLine({
						faType: '',
						text: line
					}));
				}
				if (deleted.length > 0 || added.length > 0 || changed.length > 0 || updated.length > 0) {
					this[label] = new ChangeRequestLogField({
						label: label,
						logItems: deleted.concat(added).concat(changed).concat(updated)
					});
				}
			}
		}

		// Designated Construction Zone
		else if (log.dataModel == "lcrDcz") {
			let changedFieldkey = null;
			let changedFieldValue = null;
			if (log.changes != null) {
				changedFieldkey = JSON.parse(log.changes)["Key"];
				changedFieldValue = JSON.parse(log.changes)["Value"];
			}

			if (changedFieldkey == "DczRequired") {
				this[changedFieldkey] = new ChangeRequestLogField({
					label: changedFieldkey,
					value: changedFieldValue,
					formatter: value => value == 0 ? "Not Required" : "Required"
				});
			} else if (changedFieldkey == "DczTemporaryTcRemoved") {
				this[changedFieldkey] = new ChangeRequestLogField({
					label: changedFieldkey,
					value: changedFieldValue,
					formatter: value => value == 0 ? "Not Temporary Removed" : "Temporary Removed"
				});
			} else {
				this[changedFieldkey] = new ChangeRequestLogField({
					label: changedFieldkey,
					value: changedFieldValue
				});
			}
		}

		// Transit
		else if (log.dataModel == "lcrTransit") {
			let changedFieldkey = null;
			let changedFieldValue = null;
			if (log.changes != null) {
				changedFieldkey = JSON.parse(log.changes)["Key"];
				changedFieldValue = JSON.parse(log.changes)["Value"];
			}

			if (changedFieldkey == "TransitAffected") {
				this[changedFieldkey] = new ChangeRequestLogField({
					label: changedFieldkey,
					value: changedFieldValue,
					formatter: value => value == 0 ? "Transit Not Affected" : "Transit Affected"
				});
			} else if (changedFieldkey == "Transit") {
				let details = JSON.parse(log.changesDetails);
				let deleted = [],
					added = [];
				if (details != null) {

					if (details["Deleted"]) {
						deleted = details["Deleted"].map(item => new ChangeRequestLogLine({
							faType: 'minus-circle',
							text: `Removed <b>${Format.searchById(item["TransitEffectId"], LaneClosureRequest.getAffectTransitOptions).name}</b>`
						}));
					}
					if (details["Added"]) {
						added = details["Added"].map(item => new ChangeRequestLogLine({
							faType: 'plus-circle',
							text: `Added <b>${Format.searchById(item["TransitEffectId"], LaneClosureRequest.getAffectTransitOptions).name}</b>`
						}));
					}

					this[changedFieldkey] = new ChangeRequestLogField({
						label: "lcrTransit",
						logItems: deleted.concat(added)
					});
				}
			} else {
				this[changedFieldkey] = new ChangeRequestLogField({
					label: changedFieldkey,
					value: changedFieldValue
				});
			}
		}

		// Parking
		else if (log.dataModel == "lcrParking") {
			let changedFieldkey = null;
			let changedFieldValue = null;
			if (log.changes != null) {
				changedFieldkey = JSON.parse(log.changes)["Key"];
				changedFieldValue = JSON.parse(log.changes)["Value"];
			}

			if (changedFieldkey == "PaidParkingAffected") {
				this[changedFieldkey] = new ChangeRequestLogField({
					label: changedFieldkey,
					value: changedFieldValue,
					formatter: value => value == 0 ? "Not Affect Paid Parking" : "Affect Paid Parking"
				});
			} else if (changedFieldkey == "ParkingRemovalId") {
				this[changedFieldkey] = new ChangeRequestLogField({
					label: changedFieldkey,
					value: changedFieldValue,
					formatter: value => Format.searchById(value, LaneClosureRequest.getParkingRemoveOptions).name
				});
			} else if (changedFieldkey == "ParkingLane") {
				let details = JSON.parse(log.changesDetails);
				let deleted = [],
					added = [];
				if (details != null) {
					if (details["Deleted"]) {
						deleted = details["Deleted"].map(lane => new ChangeRequestLogLine({
							faType: 'minus-circle',
							text: `Removed <b>${Format.searchById(lane.LaneId, LaneClosureRequest.getParkingLaneOptions).name}</b>`
						}));
					}
					if (details["Added"]) {
						added = details["Added"].map(lane => new ChangeRequestLogLine({
							faType: 'plus-circle',
							text: `Added <b>${Format.searchById(lane.LaneId, LaneClosureRequest.getParkingLaneOptions).name}</b>`
						}));
					}

					this[changedFieldkey] = new ChangeRequestLogField({
						label: changedFieldkey,
						logItems: deleted.concat(added)
					});
				}
			} else {
				this[changedFieldkey] = new ChangeRequestLogField({
					label: changedFieldkey,
					value: changedFieldValue
				});
			}
		}

		// Permit
		else if (log.dataModel == "lcrPermit") {
			let changedFieldkey = null;
			let changedFieldValue = null;
			if (log.changes != null) {
				changedFieldkey = JSON.parse(log.changes)["Key"];
				changedFieldValue = JSON.parse(log.changes)["Value"];
			}

			if (changedFieldkey == "PermitRequired") {
				this[changedFieldkey] = new ChangeRequestLogField({
					label: changedFieldkey,
					value: changedFieldValue,
					formatter: value => value == 0 ? "Not Required" : "Required"
				});
			} else if (changedFieldkey == "PermitLiabilityInsurance") {
				this[changedFieldkey] = new ChangeRequestLogField({
					label: changedFieldkey,
					value: changedFieldValue,
					formatter: value => value == 0 ? "No" : "Yes"
				});
			} else if (changedFieldkey == "CrossingPermitRequired") {
				this[changedFieldkey] = new ChangeRequestLogField({
					label: changedFieldkey,
					value: changedFieldValue,
					formatter: value => value == 0 ? "Not Required" : "Required"
				});
			} else {
				this[changedFieldkey] = new ChangeRequestLogField({
					label: changedFieldkey,
					value: changedFieldValue
				});
			}
		}

		// Attachments
		else if (log.dataModel == "lcr_attachment") {
			let details = JSON.parse(log.changesDetails);
			if (details != null) {
				Object.keys(details).forEach(key => {
					this[key] = new ChangeRequestLogField({
						label: key,
						logItems: [new ChangeRequestLogLine(details[key] == null ? "None" : details[key])]
					});
				})
			}
		} else if (log.dataModel == "message") {
			let details = JSON.parse(log.changesDetails);
			if (details != null) {
				Object.keys(details).forEach(key => {
					this[key] = new ChangeRequestLogField({
						label: key,
						logItems: [new ChangeRequestLogLine(details[key] == null ? "None" : details[key])]
					});
				})
			}
		} else if (log.dataModel == "notification") {
			let details = JSON.parse(log.changesDetails);
			if (details != null) {
				if (typeof this["recipients"] == "undefined") {
					this["recipients"] = new ChangeRequestLogField({
						label: "Recipient",
						logItems: details.Recipients.map(person => new ChangeRequestLogLine(`${person.Name} (${person.Email})`))
					});
				} else {
					var person = details.Recipients.map(person => new ChangeRequestLogLine(`${person.Name} (${person.Email})`));
					if (person) {
						this["recipients"].logItems.push(person[0]);
					}
				}
			}

		} else if (log.dataModel == "contravention") {
			if (log.changes != null) {
				let changedFieldkey = null;
				let changedFieldValue = null;
				if (log.changes != null) {
					changedFieldkey = JSON.parse(log.changes)["Key"];
					changedFieldValue = JSON.parse(log.changes)["Value"];
				}
				if (changedFieldkey == "OfficerId") {
					let details = JSON.parse(log.changesDetails);

					this[changedFieldkey] = new ChangeRequestLogField({
						label: changedFieldkey,
						value: details["Officer"],
						formatter: value => `${value.FirstName} ${value.LastName}, ${this.getOrganizationTreeText(value)}`
					});
				} else if (changedFieldkey == "TypeId") {
					this[changedFieldkey] = new ChangeRequestLogField({
						label: changedFieldkey,
						value: changedFieldValue,
						formatter: value => Format.searchById(value, Contravention.getContraventionTypeIdOptions).name
					});
				} else {
					this[changedFieldkey] = new ChangeRequestLogField({
						label: changedFieldkey,
						value: changedFieldValue
					});
				}
			}
		}

		// User
		else if (log.dataModel == "app_user") {
			let changedFieldkey = null;
			let changedFieldValue = null;
			if (log.changes != null) {
				changedFieldkey = JSON.parse(log.changes)["Key"];
				changedFieldValue = JSON.parse(log.changes)["Value"];
			}

			if (changedFieldkey == "IsActive") {
				this[changedFieldkey] = new ChangeRequestLogField({
					label: "UserActive",
					value: changedFieldValue,
					formatter: value => value == 0 ? "Not Active" : "Active"
				});
			} else if (changedFieldkey == "SupervisorUserId") {
				let details = JSON.parse(log.changesDetails);
				let detailField = details["SupervisorUser"]
				let oldUser = null,
					newUser = null;
				if (detailField[0]) oldUser = `${detailField[0].FirstName} ${detailField[0].LastName}, ${this.getOrganizationTreeText(detailField[0])}`;
				if (detailField[1]) newUser = `${detailField[1].FirstName} ${detailField[1].LastName}, ${this.getOrganizationTreeText(detailField[1])}`;
				this[changedFieldkey] = new ChangeRequestLogField({
					label: changedFieldkey,
					value: [oldUser, newUser],
				});
			} else if (changedFieldkey == "AlternateUserId") {
				let details = JSON.parse(log.changesDetails);

				if (details != null) {
					let detailField = details["AlternateUser"]
					let oldUser = null,
						newUser = null;
					if (detailField[0]) oldUser = `${detailField[0].FirstName} ${detailField[0].LastName}, ${this.getOrganizationTreeText(detailField[0])}`;
					if (detailField[1]) newUser = `${detailField[1].FirstName} ${detailField[1].LastName}, ${this.getOrganizationTreeText(detailField[1])}`;
					this[changedFieldkey] = new ChangeRequestLogField({
						label: changedFieldkey,
						value: [oldUser, newUser],
					});
				}
			} else if (changedFieldkey == "IsApproved") {
				this[changedFieldkey] = new ChangeRequestLogField({
					label: changedFieldkey,
					value: changedFieldValue,
					formatter: value => value == 0 ? "Rejected" : "Approved"
				});
			} else if (changedFieldkey == "IsAway") {
				this[changedFieldkey] = new ChangeRequestLogField({
					label: changedFieldkey,
					value: changedFieldValue,
					formatter: value => value == 0 ? "Not Away" : "Away"
				});
			} else if (changedFieldkey == "OrganizationId") {
				let details = JSON.parse(log.changesDetails);
				if (details != null) {
					this[changedFieldkey] = new ChangeRequestLogField({
						label: changedFieldkey,
						value: details["Organization"],
					});
				}
			} else if (changedFieldkey == "NotificationSetting") {
				let details = JSON.parse(log.changesDetails);
				let generateText = (typeId, switchId) => {
					let switchNotificationName = "";
					let forRequestType = "";

					switch (switchId) {
						case 'NotifyEmailAllLcr':
							switchNotificationName = "Email";
							forRequestType = "organizationRequest";
							break;
						case 'NotifyEmailMyLcr':
							switchNotificationName = "Email";
							forRequestType = "myRequest";
							break;

						case 'NotifyAppAllLcr':
							switchNotificationName = "App";
							forRequestType = "organizationRequest";
							break;
						case 'NotifyAppMyLcr':
							switchNotificationName = "App";
							forRequestType = "myRequest";
							break;

						case 'NotifyBrowserAllLcr':
							switchNotificationName = "Browser";
							forRequestType = "organizationRequest";
							break;
						case 'NotifyBrowserMyLcr':
							switchNotificationName = "Browser";
							forRequestType = "myRequest";
							break;

						case 'NotifySoundAllLcr':
							switchNotificationName = "Sound";
							forRequestType = "organizationRequest";
							break;
						case 'NotifySoundMyLcr':
							switchNotificationName = "Sound";
							forRequestType = "myRequest";
							break;
					}
					return `<b>${switchNotificationName}</b> for <b>${$t.call(vueObj, 'auditLog.userSettings.' + typeId)}</b> for <b>${$t.call(vueObj, 'auditLog.userSettings.' + forRequestType)}</b>`;
				};

				let notificationLines = [];
				if (details != null) {
					details.On.forEach(x => {
						x.NotificationSwitches.forEach(y => {
							notificationLines.push(new ChangeRequestLogLine({
								faType: 'plus-circle',
								text: 'Turned on ' + generateText(x.NotificationTypeId, y),
							}));
						});
					});
					details.Off.forEach(x => {
						x.NotificationSwitches.forEach(y => {
							notificationLines.push(new ChangeRequestLogLine({
								faType: 'minus-circle',
								text: 'Turned off ' + generateText(x.NotificationTypeId, y),
							}));
						});
					});
				}
				this[changedFieldkey] = new ChangeRequestLogField({
					label: changedFieldkey,
					logItems: notificationLines,
				})
			} else {
				this[changedFieldkey] = new ChangeRequestLogField({
					label: changedFieldkey,
					value: changedFieldValue
				});
			}
		}

		// Organization
		else if (log.dataModel == "organization") {
			let changedFieldkey = null;
			let changedFieldValue = null;
			if (log.changes != null) {
				changedFieldkey = JSON.parse(log.changes)["Key"];
				changedFieldValue = JSON.parse(log.changes)["Value"];
			}

			if (changedFieldkey == "IsActive") {
				this[changedFieldkey] = new ChangeRequestLogField({
					label: "OrganizationActive",
					value: changedFieldValue,
					formatter: value => value == 0 ? "Not Active" : "Active"
				});
			} else if (changedFieldkey == "ParentId") {
				let details = JSON.parse(log.changesDetails);
				if (details != null) {

					let detailField = details["ParentOrganization"];
					let oldOrg = null,
						newOrg = null;
					if (detailField[0]) oldOrg = detailField[0].Name;
					if (detailField[1]) newOrg = detailField[1].Name;

					this[changedFieldkey] = new ChangeRequestLogField({
						label: changedFieldkey,
						value: [oldOrg, newOrg]
					});
				}
			} else if (changedFieldkey == "OrganizationTypeId") {
				this[changedFieldkey] = new ChangeRequestLogField({
					label: changedFieldkey,
					value: changedFieldValue,
					formatter: value => Organization.searchById(value, Organization.getOrganizationTypeId).text
				});
			} else if (changedFieldkey == "Comments") {
				this[changedFieldkey] = new ChangeRequestLogField({
					label: "OrganizationComments",
					value: changedFieldValue
				});
			} else {
				this[changedFieldkey] = new ChangeRequestLogField({
					label: changedFieldkey,
					value: changedFieldValue
				});
			}
		}

		// Preset Block
		else if (log.dataModel == "lcrPresetBlock") {
				let changedFieldkey = null;
				// let changedFieldValue = null;
				if (log.changes != null) {
					changedFieldkey = JSON.parse(log.changes)["Key"];
					// changedFieldValue = JSON.parse(log.changes)["Value"];
				}

				let details = JSON.parse(log.changesDetails);
				let added = [],
					deleted = [];

				let getlaneOptionIdName = (lane) => {
					let result = "",
						direction = "",
						peak = "";
					switch (lane.LaneType) {
						case "Lane":
							result = Format.searchByGroupedId(lane.LaneId, LaneClosureRequest.getLaneAffectedOptions);
							peak = Format.searchByGroupedId(lane.PeakId, LaneClosureRequest.getClosurePeakReason).name;
							result = `<img src="${result.img}" width="25" height="25" /> <b>${result.name} (${peak})</b>`;
							break;
						case "Bicycle":
							result = Format.searchById(lane.LaneId, LaneClosureRequest.getBicycleLaneOptions);
							result = `<img src="${result.img}" width="20" height="20" /> <b>${result.name}</b>`;
							break;
						case "Sidewalk":
							result = Format.searchById(lane.LaneId, LaneClosureRequest.getSidewalkOptions);
							result = `<img src="${result.img}" width="20" height="20" /> <b>${result.name}</b>`;
							break;
						case "Restriction":
							result = Format.searchById(lane.LaneId, LaneClosureRequest.getTurningRestrictionTypeOptions);
							direction = Format.searchById(lane.DirectionId, LaneClosureRequest.getDirectionIdOptions).name;
							peak = Format.searchByGroupedId(lane.PeakId, LaneClosureRequest.getClosurePeakReason).name;
							result = `<img src="${result.img}" width="20" height="20" /> <b>${direction} ${result.name} (${peak})</b>`;
							break;
					}
					return result;
				}
				if (details != null) {
					if (details["Added"]) {
						added = details["Added"].map(lane => `Added ${getlaneOptionIdName(lane)}`).map(line => new ChangeRequestLogLine({
							faType: 'plus-circle',
							text: line
						}));
					}
					if (details["Deleted"]) {
						deleted = details["Deleted"].map(lane => `Removed ${getlaneOptionIdName(lane)}`).map(line => new ChangeRequestLogLine({
							faType: 'minus-circle',
							text: line
						}));
					}
				}
				this[changedFieldkey] = new ChangeRequestLogField({
					label: changedFieldkey,
					logItems: added.concat(deleted)
				});

				// Acting as Authorized Construction Agency
			}	else if (log.dataModel == "lcrAca") {
					let changedFieldkey = null;
					let changedFieldValue = null;
					if (log.changes != null) {
						changedFieldkey = JSON.parse(log.changes)["Key"];
						changedFieldValue = JSON.parse(log.changes)["Value"];
					}
					console.log(changedFieldkey);



					if (changedFieldkey == "AcaParkingRemoval") {
						this[changedFieldkey] = new ChangeRequestLogField({
							label: changedFieldkey,
							value: changedFieldValue,
							formatter: value => value == 0 ? "NOT Acting as ACA for Parking Removal" : "Acting as ACA  for Parking Removal"
						});
					} else 	if (changedFieldkey == "ActAsAca") {
							this[changedFieldkey] = new ChangeRequestLogField({
								label: changedFieldkey,
								value: changedFieldValue,
								formatter: value => value == 0 ? "NOT Acting as ACA" : "Acting as ACA"
							});
					} else 	if (changedFieldkey == "AcaTurnRestrictions") {
							this[changedFieldkey] = new ChangeRequestLogField({
								label: changedFieldkey,
								value: changedFieldValue,
								formatter: value => value == 0 ? "NOT Acting as ACA for Turn Restrictions" : "Acting as ACA for Turn Restrictions"
							});
					} else 	if (changedFieldkey == "AcaFullDirectional") {
							this[changedFieldkey] = new ChangeRequestLogField({
								label: changedFieldkey,
								value: changedFieldValue,
								formatter: value => value == 0 ? "NOT Acting as ACA for Full or Directional Closure of a Regional Street" : "Acting as ACA for Full or Directional Closure of a Regional Street "
							});

					} else 	if (changedFieldkey == "AcaDcz") {
							this[changedFieldkey] = new ChangeRequestLogField({
								label: changedFieldkey,
								value: changedFieldValue,
								formatter: value => value == 0 ? "NOT Acting as ACA for Designated Construction Zone (DCZ)" : "Acting as ACA for Designated Construction Zone (DCZ) "
							});
					} else {
						this[changedFieldkey] = new ChangeRequestLogField({
							label: changedFieldkey,
							value: changedFieldValue
						});
					}
		} else {

			console.log("no matching line", log.dataModel);
			console.log(log.changes);
		}
	}

	getAuditFields() {
		return Object.values(this);
	}

	getStepFields(step) {
		var stepFields = [];
		switch(step) {
			case "all":
				stepFields = [
					"IsEmergency"
					,"NatureOfWorkId"
					,"AffectedStreet"
					,"DirectionId"
					,"FirstCrossStreet"
					,"LastCrossStreet"
					,"lcrAca"
					,"ActAsAca"
					,"AcaParkingRemoval"
					,"AcaTurnRestrictions"
					,"AcaFullDirectional"
					,"AcaDcz"
					,"IsUnderTwoHours"
					,"FromDate"
					,"FromTime"
					,"ToDate"
					,"ToTime"
					,"RequesterProjectId"
					,"RequesterId"
					,"ClosureReporterId"
					,"RestrictionReporterId"
					,"lcrAltRequester"
					,"lcrAltClosureReporter"
					,"lcrAltRestrictionReporter"
					,"lcrLane"
					,"LanesClosedSameTime"
					,"lcrSidewalk"
					,"lcrBicycle"
					,"lcrRestriction"
					,"lcrTrafficSignal"
					,"TempTrafficControl"
					,"TrafficEffect"
					,"WorkZoneKph"
					,"DczRequired"
					,"DczLimits"
					,"DczTemporaryTcRemoved"
					,"DczHazards"
					,"DczHoursOfWork"

					,"lcrTransit"
					,"Transit"
					,"TransitAffected"
					,"TransitOther"
					,"TransitStopNumbers"

					,"lcrParkingRemoval"
					,"PaidParkingAffected"
					,"ParkingLane"

					,"RequesterComments"
					,"Attachment"
					,"WorkDoneForId"
					,"ProjectBidNumber"
					,"BidAdmin"
					,"WfseoControlCode"
					, "WfseoPermitRequestInfo"

					,"RecordStatusId"
					,"ApprovalStatusId"
					,"CompleteTypeId"

					,"PermitRequired"
					,"PermitLiabilityInsurance"
					,"CrossingPermitRequired"
					];
					break;
			case "submitter":
						stepFields = [
						"IsEmergency"
						,"NatureOfWorkId"
						,"AffectedStreet"
						,"DirectionId"
						,"FirstCrossStreet"
						,"LastCrossStreet"
						,"lcrAca"
						,"ActAsAca"
						,"AcaParkingRemoval"
						,"AcaTurnRestrictions"
						,"AcaFullDirectional"
						,"AcaDcz"
						,"IsUnderTwoHours"
						,"FromDate"
						,"FromTime"
						,"ToDate"
						,"ToTime"
						,"RequesterProjectId"
						,"RequesterId"
						,"ClosureReporterId"
						,"RestrictionReporterId"
						,"lcrAltRequester"
						,"lcrAltClosureReporter"
						,"lcrAltRestrictionReporter"
				];
					break;
			case "closures":
				stepFields = [
				"lcrLane"
				,"LanesClosedSameTime"
				,"lcrSidewalk"
				,"lcrBicycle"
				,"lcrRestriction"
				,"lcrTrafficSignal"
				,"TempTrafficControl"
				,"TrafficEffect"
				];
					break;
			case "dcz":
				stepFields = [
				"WorkZoneKph"
				,"DczRequired"
				,"DczLimits"
				,"DczTemporaryTcRemoved"
				,"DczHazards"
				,"DczHoursOfWork"

				,"lcrTransit"
				,"Transit"
				,"TransitAffected"
				,"TransitOther"
				,"TransitStopNumbers"

				,"lcrParkingRemoval"
				,"PaidParkingAffected"
				,"ParkingLane"

				,"RequesterComments"
				,"Attachment"
				,"WorkDoneForId"


				,"RecordStatusId"
				,"ApprovalStatusId"
				,"CompleteTypeId"
				];
					break;
			case "permits":
				stepFields = [
					"PermitRequired"
					,"PermitLiabilityInsurance"
					,"PermitNearestStreetNumber"
					,"PermitRoadwayMetres"
					,"PermitRoadwayFrom"
					,"PermitRoadwayTo"
					,"PermitSidewalkMetres"
					,"PermitSidewalkFrom"
					,"PermitSidewalkTo"
					,"PermitRequests"
					,"CrossingPermitRequired"
					,"CrossingPermitLocation"
					,"CrossingPermitEquipment"
				];
				break;
		}

		return Object.values(this).filter(entry => {
			if (stepFields.includes(entry.label)) {
				return true;
			} else {
				// console.log(entry.label);
				return false;
			}
		}).sort((a, b) => stepFields.indexOf(a.label) - stepFields.indexOf(b.label));


		// // if (stepFields.length == 0) {
		// // 	return;
		// // }
		// return vals;
		// return Object.values(this);
	}

	getOrganizationTreeText(user) {
		let orgTree = user.OrganizationTree;
		if (!orgTree) return user.OrganizationName;

		let orgArray = orgTree.split('|');
		orgArray.shift();
		orgArray.pop();
		orgArray = orgArray.reverse();
		return orgArray.join(' > ');
	}
}

class ChangeRequestLogField {
	constructor(data) {
		if (data.label) {
			this.label = data.label;
		}
		if (data.logItems instanceof Array) {
			this.logItems = data.logItems;
		}

		if (typeof data.value == "undefined") {
			this.value = null;
			this.oldValue = null;
		}

		if (data.formatter instanceof Function) {
			this.formatter = data.formatter;
		} else {
			this.formatter = this.defaultFormatter;
		}

		if (data.oldFormatter instanceof Function) {
			this.oldFormatter = data.oldFormatter;
		} else {
			if (data.formatter instanceof Function) {
				this.oldFormatter = data.formatter;
			} else {
				this.oldFormatter = this.defaultFormatter;
			}
		}


		if (data.value) {
			this.value = data.value[1];
		} else {
			this.value = data.value;
		}

		this.oldValue = null;
		if (data.value) {
			if (typeof data.value[0] != "undefined" && typeof data.value[1] != "undefined") {
				this.oldValue = data.value[0];
			} else {
				this.oldValue = null;
			}
		} else {
			this.oldValue = null;
		}
	}

	getContent() {
		if (this.logItems) {
			return this.logItems;
		} else {
			let oldText = "";
			let newText = "";

			if (typeof this.value != "undefined") {
				newText = `<div class='changed-to'><span>${this.formatter(this.value)}</span></div>`;
			}
			if (typeof this.oldValue != "undefined") {
				oldText = `<div class='changed-from'><span>${this.oldFormatter(this.oldValue)}</span></div>`;
			} else {
				oldText = `<div class='changed-from'><span>Empty</span></div>`;
			}
			let chevronRight = '<div class="changed-arrow"><svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="chevron-right" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" class="svg-inline--fa fa-chevron-right fa-w-10"><path fill="currentColor" d="M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z" class=""></path></svg></div>';

			return [new ChangeRequestLogLine(`${oldText}${chevronRight}${newText}`)];

		}
		// return [new ChangeRequestLogLine("Error: can't getContent()")];
	}

	defaultFormatter(value) {
		return value == null ? "None" : value;
	}
}

class ChangeRequestLogLine {
	constructor(data) {

		if (typeof(data) == "string") {
			this.text = data;
		}
		if (data.faType) {
			this.faType = data.faType;
		}
		if (data.text) {
			this.text = data.text;
		}
	}
}